import React from "react";
import { useTranslation } from "react-i18next";
import { WeekDay } from "@/types/hotelService";

const DAYS_IN_WEEK = 7;

const AvailabilityCell = ({
  availableDays,
}: {
  availableDays?: WeekDay[] | null;
}) => {
  const { t } = useTranslation();
  if (!availableDays?.length) {
    return <span>{t("services.activity.common.na", "N/A")}</span>;
  }
  return (
    <span>
      {availableDays.length === DAYS_IN_WEEK
        ? "Whole week"
        : availableDays.join(",")}
    </span>
  );
};

export default AvailabilityCell;
